import { render, staticRenderFns } from "./HistogramChartPlotly.vue?vue&type=template&id=4a6cf21c&scoped=true&"
import script from "./HistogramChartPlotly.vue?vue&type=script&lang=js&"
export * from "./HistogramChartPlotly.vue?vue&type=script&lang=js&"
import style0 from "./HistogramChartPlotly.vue?vue&type=style&index=0&id=4a6cf21c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6cf21c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a6cf21c')) {
      api.createRecord('4a6cf21c', component.options)
    } else {
      api.reload('4a6cf21c', component.options)
    }
    module.hot.accept("./HistogramChartPlotly.vue?vue&type=template&id=4a6cf21c&scoped=true&", function () {
      api.rerender('4a6cf21c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/charts/HistogramChartPlotly.vue"
export default component.exports